/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Tutorial from '@/components/Tutorial'

import AssessmentDetail from '@/components/assessment/_id'
import AssessmentIndex from '@/components/assessment/index'
import ComplaintDetail from '@/components/complaint/_id'
import ComplaintForm from '@/components/complaint/form'
import ComplaintIndex from '@/components/complaint/index'
import ComplaintHistory from '@/components/complaint/history'

import TicketDetail from '@/components/customerService/_id'
import TicketForm from '@/components/customerService/form'
import TicketIndex from '@/components/customerService/index'
import TicketHistory from '@/components/customerService/history'

import FeedbackDetail from '@/components/feedback/_id'
import FeedbackForm from '@/components/feedback/form'
import FeedbackIndex from '@/components/feedback/index'
import FeedbackHistory from '@/components/feedback/history'

import CompoundDetail from '@/components/compound/_id'
import CompoundIndex from '@/components/compound/index'

import LicensePreview from '@/components/license/preview'
import LicenseForm from '@/components/license/form'
import LicenseDetail from '@/components/license/_id'
import LicenseIndex from '@/components/license/index'
import OperationLicenseDigitalLicense from '@/components/license/digital_license'
import OperationLicenseDigitalLicensePublic from '@/components/license/digital_license_public'

import Communications from '@/components/Communications'
import Ebilling from '@/components/Ebilling'

import TradingDetail from '@/components/trading/_id'
import TradingForm from '@/components/trading/form'
import TradingList from '@/components/trading/list'
import TradingPreview from '@/components/trading/preview'
import TradingIndex from '@/components/trading/index'
import TradingRenewal from '@/components/trading/renewal'
import TradingDigitalLicense from '@/components/trading/digital_license'
import TradingDigitalLicensePublic from '@/components/trading/digital_license_public'

import UserDetail from '@/components/user/_id'
import UserForm from '@/components/user/form'
import UserReset from '@/components/user/reset'

import PrivacyPolicy from '@/components/PrivacyPolicy'

import configurations from '@/configurations'

Vue.use(Router)

const eservices = '- MPT e-Services'
const publicMode = configurations.publicMode

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: `Home ${eservices}`
      }
    },
    {
      path: '/privacy_policy',
      name: 'privacy-policy',
      component: PrivacyPolicy,
      meta: {
        title: `Privacy Policy ${eservices}`
      }
    },
    {
      path: '/complaint',
      name: 'complaint',
      component: ComplaintIndex,
      meta: {
        title: `Complaint Index ${eservices}`
      }
    },
    {
      path: '/complaint/form',
      name: 'complaint-form',
      component: ComplaintForm,
      meta: {
        title: `Complaint Form ${eservices}`
      }
    },
    {
      path: '/complaint/detail/:id',
      name: 'complaint-id',
      component: ComplaintDetail,
      meta: {
        title: `Complaint Detail ${eservices}`
      }
    },
    {
      path: '/complaint/history',
      name: 'complaint-history',
      component: ComplaintHistory,
      meta: {
        title: `Complaint History ${eservices}`
      }
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: TicketIndex,
      meta: {
        title: `Ticket Index ${eservices}`
      }
    },
    {
      path: '/ticket/form',
      name: 'ticket-form',
      component: TicketForm,
      meta: {
        title: `Ticket Form ${eservices}`
      }
    },
    {
      path: '/ticket/detail/:id',
      name: 'ticket-id',
      component: TicketDetail,
      meta: {
        title: `Ticket Detail ${eservices}`
      }
    },
    {
      path: '/ticket/history',
      name: 'ticket-history',
      component: TicketHistory,
      meta: {
        title: `Ticket History ${eservices}`
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: FeedbackIndex,
      meta: {
        title: `Feedback Index ${eservices}`
      }
    },
    {
      path: '/feedback/form',
      name: 'feedback-form',
      component: FeedbackForm,
      meta: {
        title: `Feedback Form ${eservices}`
      }
    },
    {
      path: '/feedback/detail/:id',
      name: 'feedback-id',
      component: FeedbackDetail,
      meta: {
        title: `Feedback Detail ${eservices}`
      }
    },
    {
      path: '/feedback/history',
      name: 'feedback-history',
      component: FeedbackHistory,
      meta: {
        title: `Feedback History ${eservices}`
      }
    },
    {
      path: '/compound',
      name: 'compound',
      component: CompoundIndex,
      meta: {
        title: `Compound Index ${eservices}`
      }
    },
    {
      path: '/compound/detail/:id',
      name: 'compound-id',
      component: CompoundDetail,
      meta: {
        title: `Compound Detail ${eservices}`
      }
    },
    {
      path: '/assessment',
      name: 'assessment',
      component: AssessmentIndex,
      meta: {
        title: `Assessment Index ${eservices}`
      }
    },
    {
      path: '/assessment/detail/:id',
      name: 'assessment-id',
      component: AssessmentDetail,
      meta: {
        title: `Assessment Detail ${eservices}`
      }
    },
    {
      path: '/license',
      name: 'license',
      component: LicenseIndex,
      meta: {
        title: `License Index ${eservices}`
      }
    },
    {
      path: '/license/preview/:id',
      name: 'license-preview',
      component: LicensePreview,
      meta: {
        title: `Cpuncil License Preview ${eservices}`
      }
    },
    {
      path: '/license/form',
      name: 'license-form',
      component: LicenseForm,
      meta: {
        title: `Operating License Form ${eservices}`
      }
    },
    {
      path: '/license/detail/:id',
      name: 'license-id',
      component: LicenseDetail,
      meta: {
        title: `License Detail ${eservices}`
      }
    },
    {
      path: '/license/digital-license/:id',
      name: 'license-digital-license-id',
      component: publicMode ? OperationLicenseDigitalLicensePublic : OperationLicenseDigitalLicense,
      meta: {
        title: `Digital Operation License ${eservices}`
      }
    },
    {
      path: '/trading',
      name: 'trading',
      component: TradingIndex,
      meta: {
        title: `Trading License Index ${eservices}`
      }
    },
    {
      path: '/trading/detail/:id',
      name: 'trading-id',
      component: TradingDetail,
      meta: {
        title: `Trading License Detail ${eservices}`
      }
    },
    {
      path: '/trading/form',
      name: 'trading-form',
      component: TradingForm,
      meta: {
        title: `Trading License Form ${eservices}`
      }
    },
    {
      path: '/trading/list',
      name: 'trading-list',
      component: TradingList,
      meta: {
        title: `Trading License List ${eservices}`
      }
    },
    {
      path: '/trading/preview/:id',
      name: 'trading-preview',
      component: TradingPreview,
      meta: {
        title: `Trading License Preview ${eservices}`
      }
    },
    {
      path: '/trading/digital-license/:id',
      name: 'trading-digital-license-id',
      component: publicMode ? TradingDigitalLicensePublic : TradingDigitalLicense,
      meta: {
        title: `Trading Digital License ${eservices}`
      }
    },
    {
      path: '/trading/renewal/:id',
      name: 'trading-renewal-id',
      component: TradingRenewal,
      meta: {
        title: `Trading Renewal ${eservices}`
      }
    },
    {
      path: '/user/form',
      name: 'user-form',
      component: UserForm,
      meta: {
        title: `User Form ${eservices}`
      }
    },
    {
      path: '/user/reset/:id',
      name: 'user-reset',
      component: UserReset,
      meta: {
        title: `User Reset ${eservices}`
      }
    },
    {
      path: '/user/detail',
      name: 'user-id',
      component: UserDetail,
      meta: {
        title: `User Profile ${eservices}`
      }
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      component: Tutorial,
      meta: {
        title: `User Profile ${eservices}`
      }
    },
    {
      path: '/settings/communication',
      name: 'settings-communication',
      component: Communications,
      meta: {
        title: `Communication Setting ${eservices}`
      }
    },
    {
      path: '/e-billing',
      name: 'e-billing',
      component: Ebilling,
      meta: {
        title: `e-Billing Subscription ${eservices}`
      }
    }
  ]
})
